import { render } from "./Header.vue?vue&type=template&id=7a154d30&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=7a154d30&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a154d30"]])

export default __exports__